import * as React from 'react';

export default class Vrbo extends React.Component<{}, {}> {
  public render() {
    return <p>VRBO instructions</p>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/IntegrationInstructions/private/Vrbo.tsx